<template>
  <div>
    <div class="grid-view">
      <div class="main-content">
        <div style="width: 100%;margin-top: 5px; min-width: 1280px" class="cargo-advance-search">
          <el-form
            label-position="middle"
            label-width="100px"
          >
            <div class="el-form-item-wrapper" style="display: flex">
              <el-form-item :label="$t('CargoMsg.TENANT_BUSINESS_NAME')">
                <cargo-advance-select
                  no="1"
                  :select-type="selectTypeNames.TENANT"
                  :cache="false"
                  filterable
                  clearable
                  style="width: 230px;padding-left: 10px"
                  :custom-label="(item)=>`[${item.id}]${item.name}`"
                  callback-method-type="obj"
                  :default-value="String(filter.tenant)||''"
                  @parentCallBack="p => filter.tenant = p.value"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_CarrierShip')" label-width="70px">
                <cargo-advance-select
                  tag-value="code"
                  filterable
                  clearable
                  :multiple="true"
                  style="width: 230px;padding-left: 10px"
                  :static-options="RECEIPT_CARRIERS"
                  @parentCallBack="p=>{filter.carriers=[...p.value]}"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_Channel')" label-width="70px">
                <cargo-advance-select
                  tag-value="code"
                  filterable
                  clearable
                  style="width: 230px;padding-left: 10px"
                  :static-options="RECEIPT_CHANNELS"
                  @parentCallBack="p=>{filter.channel=p.value}"
                />
              </el-form-item>
              <div style="padding-left: 10px">
                <el-button no="3" type="primary" @click="filter.pageNum=1;queryHandler()">
                  {{ $t('CargoMsg.Cargo_Query') }}
                </el-button>
                <el-button no="4" type="primary" @click="addHandler">
                  {{ $t('CargoMsg.Cargo_Add') }}
                </el-button>
                <el-button no="5" type="primary" @click="editHandler">
                  {{ $t('CargoMsg.Cargo_Edit') }}
                </el-button>
                <el-button no="6" type="danger" @click="deleteHandler">
                  {{ $t('CargoMsg.Cargo_OrderDelete') }}
                </el-button>
              </div>
            </div>
          </el-form>
        </div>
        <div class="app-main-inner-row row-grid" style="flex-grow: 1;">
          <cargo-ag-grid
            no="grid"
            config-module="101425"
            :column-defs="columnDefs"
            :row-data="rowData"
            :grid-params.sync="girdParams"
            :grid-options="gridOptions"
          />
        </div>
        <div class="app-main-inner-row row-pagination">
          <cargo-pagination
            no="pagination"
            config-module="101425"
            :total="total"
            :page.sync="filter.pageNum"
            :limit.sync="filter.pageSize"
            @pagination="queryHandler"
          />
        </div>
      </div>
    </div>
    <!-- 新增编辑弹框 -->
    <el-dialog
      ref="settingDialog"
      v-el-drag-dialog
      :visible.sync="settingDialog.visible"
      :title="settingDialog.title"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="130px" label-position="right">
          <el-form-item :label="$t('CargoMsg.TENANT_BUSINESS_NAME')" class="lable-blue">
            <cargo-advance-select
              no="7"
              :select-type="selectTypeNames.TENANT"
              :disabled="settingDialog.isEdit"
              :cache="false"
              filterable
              clearable
              style="width: 290px"
              :custom-label="(item)=>`[${item.id}]${item.name}`"
              callback-method-type="obj"
              :default-value="String(settingDialog.form.tenant)||''"
              :static-options="tenants"
              @parentCallBack="changeTenant"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CarrierShip')" label-width="130px" class="lable-blue">
            <cargo-advance-select
              tag-value="code"
              filterable
              clearable
              style="width: 290px"
              :default-value="settingDialog.form.carrier"
              :static-options="RECEIPT_CARRIERS"
              @parentCallBack="p=>{settingDialog.form.carrier=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_Channel')" label-width="130px" class="lable-blue">
            <cargo-advance-select
              tag-value="code"
              filterable
              clearable
              style="width: 290px"
              :default-value="settingDialog.form.channel"
              :static-options="RECEIPT_CHANNELS"
              @parentCallBack="changeChannel"
            />
          </el-form-item>
          <div v-if="settingDialog.form.channel === RECEIPT_CHANNEL_EMAIL.code">
            <el-form-item :label="$t('CargoMsg.Cargo_Title')" label-width="130px">
              <div style="display: flex">
                <cargo-advance-select
                  tag-value="code"
                  filterable
                  clearable
                  style="width: 80px"
                  placeholder=" "
                  :default-value="settingDialog.form.titleOperator"
                  :static-options="RECEIPT_OPERATORS"
                  @parentCallBack="p=>{settingDialog.form.titleOperator=p.value}"
                />
                <el-input v-model="settingDialog.form.title" :no="'title'" style="width: 200px;margin-left: 10px" />
              </div>
            </el-form-item>
            <el-form-item :label="$t('SystemMaintenance.Content')" label-width="130px">
              <div style="display: flex">
                <cargo-advance-select
                  tag-value="code"
                  filterable
                  clearable
                  style="width: 80px"
                  placeholder=" "
                  :default-value="settingDialog.form.contentOperator"
                  :static-options="RECEIPT_OPERATORS"
                  @parentCallBack="p=>{settingDialog.form.contentOperator=p.value}"
                />
                <el-input v-model="settingDialog.form.content" :no="'content'" style="width: 200px;margin-left: 10px" />
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="13" type="primary" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        <el-button no="14" @click="settingDialog.visible=false">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import ColumnUtils from '@/utils/ColumnUtils'
import {
  EMAIL_PARSING_TYPE,
  RECEIPT_CARRIERS, RECEIPT_CHANNEL_EMAIL,
  RECEIPT_CHANNELS,
  RECEIPT_OPERATORS
} from '@/class/cargo/model/parameters/SystemConstants'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import { getAllTenant } from '@/api/auth'
import { deleteReceiptConfig, queryReceiptConfig, saveReceiptConfig } from '@/api/sysManage/ReceiptSettings'

export default {
  name: 'ReceiptSettings',
  components: {
    AutoNumberInput,
    CargoAdvanceSelect
  },
  data() {
    return {
      RECEIPT_CARRIERS, RECEIPT_CHANNELS, RECEIPT_OPERATORS, RECEIPT_CHANNEL_EMAIL,
      total: 0,
      isZh: this.$store.getters.language === 'zh',
      EMAIL_PARSING_TYPE,
      selectTypeNames: TYPE_NAMES,
      loading: false,
      currentExpress: null,
      selectedRow: null,
      tenants: [],
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          filter: true
        }
      },
      filter: {
        pageNum: 1,
        pageSize: 50
      },
      settingDialog: {
        isEdit: false,
        title: this.$t('CargoMsg.Cargo_AddEditReadReceiptMethod'),
        visible: false,
        form: {
          uuid: '',
          version: 0,
          tenant: '',
          tenantName: '',
          carrier: '',
          channel: RECEIPT_CHANNEL_EMAIL.code,
          titleOperator: '',
          title: '',
          contentOperator: '',
          content: ''
        }
      },
      rowData: [],
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: 'TenantId',
          field: 'tenant',
          width: 120
        }, {
          headerName: this.$t('CargoMsg.TENANT_BUSINESS_NAME'),
          field: 'tenantName',
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_CarrierShip'),
          field: 'carrier',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.receiptCarrierLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Channel'),
          field: 'channel',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.receiptChannelLabelFunc(params.value)
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_Title'),
          field: 'title',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.receiptTitleLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.receiptTitleLabelFunc(params.data)
          }
        }, {
          headerName: this.$t('SystemMaintenance.Content'),
          field: 'content',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.receiptContentLabelFunc(params.data)
          },
          filterParams: {},
          filterValueGetter: (params) => {
            return ColumnUtils.receiptContentLabelFunc(params.data)
          }
        }, {
          headerName: this.$t(this.$t('CargoMsg.Cargo_OperateBy')),
          field: 'modifiedBy',
          width: 200,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        }, {
          headerName: this.$t(this.$t('CargoMsg.Cargo_OperateTime')),
          field: 'dateModified',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        }
      ]
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    getAllTenant().then(res => {
      this.tenants = res.data
    })
  },
  mounted() {
    this.queryHandler()
  },
  methods: {
    handleClick() {},
    queryHandler() {
      this.loading = getLoading4Cxt(this)
      queryReceiptConfig(this.filter).then(res => {
        if (res.data) {
          if (this.gridApi) {
            this.gridApi.setRowData(res.data.list)
          } else {
            this.rowData = res.data.list
          }
          this.filter.pageNum = res.data.pageNum
          this.filter.pageSize = res.data.pageSize
          this.total = Number(res.data.total)
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    addHandler() {
      this.settingDialog.form = {
        uuid: '',
        version: 0,
        tenant: '',
        tenantName: '',
        carrier: '',
        channel: RECEIPT_CHANNEL_EMAIL.code,
        titleOperator: '',
        title: '',
        contentOperator: '',
        content: ''
      }
      this.settingDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_ReadReceiptMethod')
      this.settingDialog.isEdit = false
      this.settingDialog.visible = true
    },
    editHandler() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      if (rows.length !== 1) {
        this.$message.warning(this.$t('common.tips.hasOneOnly'))
        return
      }
      this.settingDialog.form = { ...rows[0] }
      this.settingDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_ReadReceiptMethod')
      this.settingDialog.isEdit = true
      this.settingDialog.visible = true
    },
    deleteHandler() {
      const selectedRows = this.gridApi.getSelectedRows()
      if (selectedRows.length <= 0) {
        this.$message.error(this.$t('common.tips.hasOneAtleast'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_DeleteReceiptTip'), this.$t('Message.WarmReminder'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
        cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        this.loading = getLoading4Cxt(this)
        const data = {
          keys: Array.from(selectedRows, p => p.uuid)
        }
        deleteReceiptConfig(data).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.queryHandler()
        }).finally(() => {
          this.loading.close()
        })
      })
    },
    saveHandler() {
      const form = { ...this.settingDialog.form }
      if (!form.tenant) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.TENANT_BUSINESS_NAME'))
        return
      }
      if (!form.carrier) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_CarrierShip'))
        return
      }
      if (!form.channel) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Channel'))
        return
      }
      if (form.title && !form.titleOperator) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('CargoMsg.Cargo_Title') + this.$t('CargoMsg.Cargo_Relationship'))
        return
      }
      if (form.content && !form.contentOperator) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelect') + this.$t('SystemMaintenance.Content') + this.$t('CargoMsg.Cargo_Relationship'))
        return
      }
      if (!form.title && !form.content && !form.title.trim() && !form.content.trim()) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseInputTitleOrContentTip'))
        return
      }
      const loading = getLoading4Cxt(this.$refs.settingDialog)
      form.tenant = Number(this.settingDialog.form.tenant)
      saveReceiptConfig(form).then(() => {
        if (!form.uuid) {
          this.filter.pageNum = 1
        }
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
        this.settingDialog.visible = false
        this.queryHandler()
      }).finally(() => {
        loading.close()
      })
    },
    changeTenant(p) {
      this.settingDialog.form.tenant = p.value
      this.settingDialog.form.tenantName = p.name
    },
    changeChannel(p) {
      this.settingDialog.form.channel = p.value
      if (this.settingDialog.form.channel !== RECEIPT_CHANNEL_EMAIL.code) {
        this.settingDialog.form.titleOperator = ''
        this.settingDialog.form.title = ''
        this.settingDialog.form.contentOperator = ''
        this.settingDialog.form.content = ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>

#app /deep/ .el-form-item__label {
  text-align: right;
}

.lable-blue ::v-deep {
  .el-form-item__label {
    color: #1F75D5 !important;
  }
}

</style>
